module.exports = __webpack_public_path__ + "img/4.c526d9ed.png";